import React from 'react'

function TypeformInstance () {
  return (
    <iframe
      title='Apply for Metafest'
      src='https://form.typeform.com/to/BClVBF4E'
      style={{ height: '100%', width: '100%', border: '0px' }}
    />
  )
}

export default TypeformInstance
